// src/contexts/LanguageContext.js
import React, { createContext, useContext, useState, useEffect } from "react"
import { DEFAULT_LANG } from "../utils/i18n"

const LanguageContext = createContext(DEFAULT_LANG)

export const LanguageProvider = ({ lang, children }) => {
  const [currentLang, setCurrentLang] = useState(lang || DEFAULT_LANG)

  useEffect(() => {
    if (lang) {
      setCurrentLang(lang)
      if (typeof window !== "undefined") {
        localStorage.setItem("preferred-lang", lang)
      }
    }
  }, [lang])

  return (
    <LanguageContext.Provider value={currentLang}>
      {children}
    </LanguageContext.Provider>
  )
}

export const useLang = () => useContext(LanguageContext)

export default LanguageContext
